const translations: Record<string, string> = {
  "ak_home_january": "Січень",
  "ak_home_february": "Лютий",
  "ak_home_march": "Березень",
  "ak_home_april": "Квітень",
  "ak_home_may": "Травень",
  "ak_home_june": "Червень",
  "ak_home_july": "Липень",
  "ak_home_august": "Серпень",
  "ak_home_september": "Вересень",
  "ak_home_october": "Жовтень",
  "ak_home_november": "Листопад",
  "ak_home_december": "Грудень",
  "ak_home_jan": "січ",
  "ak_home_feb": "лют",
  "ak_home_mar": "бер",
  "ak_home_apr": "кві",
  "ak_home_may_2": "тра",
  "ak_home_jun": "чер",
  "ak_home_jul": "лип",
  "ak_home_aug": "сер",
  "ak_home_sep": "вер",
  "ak_home_oct": "жов",
  "ak_home_nov": "лис",
  "ak_home_dec": "гру",
  "ak_home_mon": "Пн",
  "ak_home_tue": "Вт",
  "ak_home_wed": "Ср",
  "ak_home_thu": "Чт",
  "ak_home_fri": "Пт",
  "ak_home_sat": "Сб",
  "ak_home_sun": "Нд",
  "ak_home_previous_year": "Попередній рік",
  "ak_home_previous_month": "Попередній місяць",
  "ak_home_next_year": "Наступний рік",
  "ak_home_next_month": "Наступний місяць",
  "ak_home_today": "Сьогодні",
  "ak_home_sunny": "Сонячно",
  "ak_home_mostly_clear": "Переважно ясно",
  "ak_home_partly_cloudy": "Мінлива хмарність",
  "ak_home_overcast": "Похмуро",
  "ak_home_fog": "Туман",
  "ak_home_drizzle": "Мряка",
  "ak_home_rain": "Дощ",
  "ak_home_snow": "Сніг",
  "ak_home_thunderstorm": "Гроза",
  "ak_home_alarm": "Аварія",
  "ak_home_no_data": "Немає даних",
  "ak_home_curtailed": "Обмеження",
  "ak_home_partial": "Часткова",
  "ak_home_running": "В роботі",
  "ak_home_mw": "МВт",
  "ak_home_mwh": "МВт·год",
  "ak_home_discharging": "розряд",
  "ak_home_charging": "заряд",
  "ak_home_idle": "спокій",
  "ak_home_no_data_2": "немає даних",
  "ak_home_bess": "УЗЕ",
  "ak_home_capacity": "Потужність",
  "ak_home_generation_now": "Генерація зараз",
  "ak_home_generated_today": "Згенеровано сьогодні",
  "ak_home_inverters": "Інвертори",
  "ak_home_colleague": "колего",
  "ak_home_good_night": "Доброї ночі",
  "ak_home_good_morning": "Доброго ранку",
  "ak_home_good_afternoon": "Доброго дня",
  "ak_home_good_evening": "Доброго вечора",
  "ak_home_home": "Головна",
  "ak_home_dashboard": "Дашборд",
  "ak_home_total_power": "Сумарна потужність",
  "ak_home_generated_today_2": "Вироблено сьогодні",
  "ak_home_stations_active": "Станцій активно",
  "ak_home_avg_load": "Сер. завантаження",
  "ak_home_loading_portfolio": "Завантаження портфелю…",
  "ak_home_failed_to_collect_hourly_trades_for_th": "Не вдалося зібрати погодинні торги за місяць — джерело не відповіло. Спробуйте ще раз або оберіть добу.",
  "ak_home_arithmetic_mean_by_hour_days_with_data": "середньоарифметично по годинах · діб з даними: {{n}}",
  "ak_home_uah_mwh": "грн/МВт·год",
  "ak_home_no_comparison": "немає порівняння",
  "ak_home_dam_prices": "Ціни РДН",
  "ak_home_per_day": "За добу",
  "ak_home_per_month": "За місяць",
  "ak_home_previous_day": "Попередня доба",
  "ak_home_next_day": "Наступна доба",
  "ak_home_loading": "Завантаження…",
  "ak_home_day_hr_8_23": "День (год. 8–23)",
  "ak_home_night_hr_1_7_24": "Ніч (год. 1–7, 24)",
  "ak_home_peak_hr_18_23": "Пік (год. 18–23)",
  "ak_home_semi_peak_hr_8_17": "Напівпік (год. 8–17)",
  "ak_home_calculating": "рахуємо…",
  "ak_home_recalculating": "перераховуємо…",
  "ak_home_clouds": "Хмарність",
  "ak_home_cloud_tops": "Верх хмар",
  "ak_home_wind": "Вітер",
  "ak_home_gusts": "Пориви",
  "ak_home_temperature": "Температура",
  "ak_home_precipitation": "Опади",
  "ak_home_total_precipitation": "Сума опадів",
  "ak_home_pressure": "Тиск",
  "ak_home_the_weather_map_failed_to_load": "Карта погоди не завантажилась",
  "ak_home_the_windy_service_did_not_respond_the": "Сервіс Windy не відповів на запит. Решта даних на сторінці не залежить від нього.",
  "ak_home_try_again": "Спробувати ще",
  "ak_home_january_2": "січня",
  "ak_home_february_2": "лютого",
  "ak_home_march_2": "березня",
  "ak_home_april_2": "квітня",
  "ak_home_may_3": "травня",
  "ak_home_june_2": "червня",
  "ak_home_july_2": "липня",
  "ak_home_august_2": "серпня",
  "ak_home_september_2": "вересня",
  "ak_home_october_2": "жовтня",
  "ak_home_november_2": "листопада",
  "ak_home_december_2": "грудня",
  "ak_home_minimum_over_the_period_mn_buffer_ok": "мінімум у періоді {{d}}: {{v}} млн · буфер OK",
  "ak_home_uah_k": "тис грн",
  "ak_home_uah": "грн",
  "ak_home_uah_mn": "млн грн",
  "ak_home_loan_principal_250_000_interest": "Кредит: тіло 250 000 € + %",
  "ak_home_payment_for_21_30_09": "Оплата за 21–30.09",
  "ak_home_payroll_social_tax_security": "ЗП, ЄСВ, охорона",
  "ak_home_land_lease": "Оренда землі",
  "ak_home_payment_for_1_10_10": "Оплата за 1–10.10",
  "ak_home_o_m_management_ppko": "O&M + управління/ППКО",
  "ak_home_cash_next_14_days": "Гроші · найближчі 14 днів",
  "ak_home_uah_mn_in_the_account": "млн грн на рахунку",
  "ak_home_date": "Дата",
  "ak_home_event": "Подія",
  "ak_home_amount": "Сума",
  "ak_home_mn": "млн",
  "ak_home_demo_data_from_the_reference_the_cabin": "Демонстраційні дані з референсу: рухів по рахунку кабінет поки не отримує.",
  "ak_home_chart_month": "Місяць графіка",
  "ak_home_return_the_chart_to_the_month_of_the_s": "Повернути графік до місяця обраної дати",
  "ak_home_to_selected_date": "до обраної дати",
  "ak_home_no_data_for_this_month": "Даних за цей місяць немає",
  "ak_home_generation_actual": "Генерація факт",
  "ak_home_generation_forecast": "Генерація прогноз",
  "ak_home_bess_charge": "Заряд BESS",
  "ak_home_bess_discharge": "Розряд BESS",
  "ak_home_trading_schedule": "Торговий графік",
  "ak_home_delivered_to_grid": "Відпуск у мережу",
  "ak_home_avg_realization_price": "Сер. ціна реалізації",
  "ak_home_dam_price_day_8_23": "Ціна РДН, день 8–23",
  "ak_home_income_calculated": "Дохід розрахунковий",
  "ak_home_income_planned": "Дохід плановий",
  "ak_home_income_dynamics": "Динаміка доходу",
  "ak_home_uah_k_day": "тис грн / добу",
  "ak_home_uah_mn_cumulative": "млн грн, накопичено",
  "ak_home_day_plan": "план дня",
  "ak_home_day_actual": "факт дня",
  "ak_home_cumulative_plan": "накопичено план",
  "ak_home_cumulative_actual": "накопичено факт",
};

export default translations;
